// mesbot/src/institution/pages/Settings.js
import React, { useEffect, useState } from "react";
import { getSettings, patchSettings } from "../api";

export default function Settings({ token }) {
  const [settings, setSettings] = useState(null);
  const [name, setName] = useState("");
  const [pilotStart, setPilotStart] = useState("");
  const [pilotEnd, setPilotEnd] = useState("");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    getSettings(token).then(data => {
      setSettings(data);
      setName(data.name);
      setPilotStart(data.pilot_start_date ? data.pilot_start_date.slice(0, 10) : "");
      setPilotEnd(data.pilot_end_date ? data.pilot_end_date.slice(0, 10) : "");
    });
  }, [token]);

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    setSaved(false);
    setError("");
    try {
      const updated = await patchSettings(token, {
        name,
        pilot_start_date: pilotStart || null,
        pilot_end_date: pilotEnd || null,
      });
      setSettings(updated);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  function copyAccessCode() {
    navigator.clipboard.writeText(settings?.access_code || "");
  }

  if (!settings) return <div style={{ color: "#6b7280" }}>Loading...</div>;

  return (
    <>
      <div className="inst-page-title">Settings</div>
      <div className="inst-page-subtitle">Institution configuration</div>

      {error && <div className="inst-error">{error}</div>}

      <div className="inst-panel" style={{ maxWidth: 560 }}>
        <form onSubmit={handleSave}>
          <div className="inst-form-group">
            <label className="inst-label">Institution Name</label>
            <input
              className="inst-input"
              value={name}
              onChange={e => setName(e.target.value)}
              required
            />
          </div>

          <div className="inst-form-group">
            <label className="inst-label">Slug (read-only)</label>
            <input className="inst-input readonly" readOnly value={settings.slug} />
          </div>

          <div className="inst-form-group">
            <label className="inst-label">Student Access Code</label>
            <div style={{ display: "flex", gap: 8 }}>
              <input className="inst-input readonly" readOnly value={settings.access_code} style={{ flex: 1 }} />
              <button type="button" className="inst-btn inst-btn-ghost" onClick={copyAccessCode}>
                Copy
              </button>
            </div>
          </div>

          <div style={{ display: "flex", gap: 16 }}>
            <div className="inst-form-group" style={{ flex: 1 }}>
              <label className="inst-label">Pilot Start Date</label>
              <input
                className="inst-input"
                type="date"
                value={pilotStart}
                onChange={e => setPilotStart(e.target.value)}
              />
            </div>
            <div className="inst-form-group" style={{ flex: 1 }}>
              <label className="inst-label">Pilot End Date</label>
              <input
                className="inst-input"
                type="date"
                value={pilotEnd}
                onChange={e => setPilotEnd(e.target.value)}
              />
            </div>
          </div>

          <div className="inst-form-group">
            <label className="inst-label">Data Use Agreement</label>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 4 }}>
              <span className={`inst-badge ${settings.dua_signed ? "active" : "inactive"}`}>
                {settings.dua_signed ? "Signed" : "Pending"}
              </span>
              {!settings.dua_signed && (
                <span style={{ fontSize: 11, color: "#6b7280" }}>
                  Contact Rigby to get your DUA signed and enable the student roster.
                </span>
              )}
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button className="inst-btn inst-btn-primary" type="submit" disabled={saving}>
              {saving ? "Saving..." : "Save Changes"}
            </button>
            {saved && <span style={{ color: "#16a34a", fontSize: 12 }}>Saved</span>}
          </div>
        </form>
      </div>
    </>
  );
}
